import { render, staticRenderFns } from "./PromoAlert.vue?vue&type=template&id=4efb9dff&scoped=true"
import script from "./PromoAlert.vue?vue&type=script&lang=js"
export * from "./PromoAlert.vue?vue&type=script&lang=js"
import style0 from "./PromoAlert.vue?vue&type=style&index=0&id=4efb9dff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efb9dff",
  null
  
)

export default component.exports